import { StrictMode } from "react";
import { render } from "react-dom";
import App from "./App";
import { makeServer } from "./server";
import "./i18n";
import environment from "environment";

// Run the mock Mirage.js server if in Dev Environment
if (environment.isDevelopment) makeServer({ environment: "development" });

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
